import styled from 'styled-components';

export const ButtonWrapper = styled.button<{ isWide: boolean; isAboveStickyCTA: boolean }>`
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;

  cursor: pointer;
  z-index: 1000;

  background-color: white;
  color: white;
  border: 1px solid black;
  width: ${(props) => (props.isWide ? '340px' : '48px')};
  min-width: 48px;
  height: 48px;

  border-radius: 9999px;
  padding: 0.75rem;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  transition: all 0.4s ease;
  overflow: hidden;

  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  @media (hover: hover) {
    &:hover {
      background: #e0e0e0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      svg path {
        fill: #555555;
      }

      .example-prompt {
        color: #555555;
      }
    }
  }

  &:focus-visible {
    outline: none;
  }

  @media (max-width: 768px) {
    padding: 0.4rem;
    height: 48px;
    bottom: ${(props) => (props.isAboveStickyCTA ? '128px' : '1rem')};
    right: 3%;
    width: ${(props) => (props.isWide ? '94%' : '48px')};
  }
`;

export const ExamplePrompt = styled.span`
  flex-grow: 1;
  font-family: Lato;
  font-weight: 700;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  transition:
    opacity 0.4s ease,
    max-width 0.4s ease,
    margin 0.4s ease;
`;
